import { auth0contactError, contact, emptyContact } from "../../../model/contact";
import { tag } from "../../../model/tag";
import { reservation } from "../../../model/reservation";

export interface IState {
    contacts: Array<contact>;
    recentContacts: Array<contact>;
    page: number;
    totalRows: number;
    tags: Array<tag>;
    // selectedContact?: contact;
    contactReservations: reservation[];
    selectedTag?: tag;
    contact: contact;
    auth0contactError?: auth0contactError;
    setBlockDate?: Date;
    isLoadingContacts: boolean;
    isLoadingContact: boolean;
    isLoadingContactReservations: boolean;
    isContactFetchInError: boolean;
    isContactReservationFetchInError: boolean;
}


export const DefaultState = (): IState => ({
    contacts: [],
    recentContacts: [],
    page: 0,
    totalRows: 0,
    contact: emptyContact(),
    contactReservations: [],
    isLoadingContacts: false,
    isLoadingContact: false,
    isLoadingContactReservations: false,
    isContactFetchInError: false,
    isContactReservationFetchInError: false,
    tags: []
})
